document.addEventListener("DOMContentLoaded", () => {

  const menuToggle = document.getElementById("menuToggle");
  const desktopNav = document.querySelector(".desktop-nav");
  const navClose = document.getElementById("navClose");

  menuToggle.addEventListener("click", function (e) {

    e.stopPropagation();

    desktopNav.classList.toggle("active");

    this.innerHTML = desktopNav.classList.contains("active")
      ? '<i class="fa-solid fa-xmark"></i>'
      : '<i class="fa-solid fa-bars"></i>';

  });

  desktopNav.addEventListener("click", function (e) {
    e.stopPropagation();
  });
  navClose.addEventListener("click", () => {

    desktopNav.classList.remove("active");

    menuToggle.innerHTML = '<i class="fa-solid fa-bars"></i>';

  });
  document.addEventListener("click", function () {

    if (window.innerWidth <= 992) {

      desktopNav.classList.remove("active");

      menuToggle.innerHTML =
        '<i class="fa-solid fa-bars"></i>';

    }

  });
  // mobile menu
  document.querySelectorAll(".dropdown > a").forEach(link => {

    link.addEventListener("click", function(e){

        if(window.innerWidth > 992) return;

        e.preventDefault();
        e.stopPropagation();

        const dropdown = this.parentElement;

        document.querySelectorAll(".dropdown").forEach(item=>{
            if(item !== dropdown){
                item.classList.remove("active");
            }
        });

        dropdown.classList.toggle("active");

    });

});

});

document.addEventListener("DOMContentLoaded", () => {

    /*==========================================
PRODUCT GALLERY
==========================================*/

const mainImage =
document.getElementById("MainProductImage");

const modalLink =
document.querySelector(".product-gallery-modal");

const thumbs =
document.querySelectorAll(".product-gallery-thumbnail");

const thumbTrack =
document.querySelector(".product-gallery-thumbnail-track");

const prevBtn =
document.querySelector(".product-gallery-thumb-prev");

const nextBtn =
document.querySelector(".product-gallery-thumb-next");

if (
mainImage &&
modalLink &&
thumbs.length
){

let currentIndex = 0;
let currentSlide = 0;

function visibleThumbs(){

return window.innerWidth < 768 ? 3 : 5;

}

function thumbWidth(){

return thumbs[0].offsetWidth + 10;

}

function maxSlide(){

return Math.max(
0,
thumbs.length-visibleThumbs()
);

}

function updateSlider(){

thumbTrack.style.transform =
`translateX(-${currentSlide*thumbWidth()}px)`;

if(prevBtn)
prevBtn.disabled =
currentSlide===0;

if(nextBtn)
nextBtn.disabled =
currentSlide>=maxSlide();

}

function setActive(index){

thumbs.forEach(t=>t.classList.remove("is-active"));

thumbs[index].classList.add("is-active");

}

function changeImage(index){

const large =
thumbs[index].dataset.large;

mainImage.src = large;

modalLink.href = large;

currentIndex = index;

setActive(index);

}

thumbs.forEach((thumb,index)=>{

thumb.addEventListener("click",()=>{

changeImage(index);

});

});

   /*==========================================
NEXT BUTTON
==========================================*/

if (nextBtn) {

    nextBtn.addEventListener("click", () => {

        if (currentSlide < maxSlide()) {

            currentSlide++;

            updateSlider();

        }

    });

}

/*==========================================
PREVIOUS BUTTON
==========================================*/

if (prevBtn) {

    prevBtn.addEventListener("click", () => {

        if (currentSlide > 0) {

            currentSlide--;

            updateSlider();

        }

    });

}

/*==========================================
KEYBOARD SUPPORT
==========================================*/

document.addEventListener("keydown", function (e) {

    if (e.key === "ArrowRight") {

        if (currentIndex < thumbs.length - 1) {

            currentIndex++;

            changeImage(currentIndex);

            if (currentIndex > currentSlide + visibleThumbs() - 1) {

                currentSlide++;

                updateSlider();

            }

        }

    }

    if (e.key === "ArrowLeft") {

        if (currentIndex > 0) {

            currentIndex--;

            changeImage(currentIndex);

            if (currentIndex < currentSlide) {

                currentSlide--;

                updateSlider();

            }

        }

    }

});

/*==========================================
TOUCH SUPPORT
==========================================*/

let startX = 0;
let endX = 0;

mainImage.addEventListener("touchstart", function (e) {

    startX = e.changedTouches[0].clientX;

});

mainImage.addEventListener("touchend", function (e) {

    endX = e.changedTouches[0].clientX;

    if (startX - endX > 50) {

        if (currentIndex < thumbs.length - 1) {

            currentIndex++;

            changeImage(currentIndex);

        }

    }

    if (endX - startX > 50) {

        if (currentIndex > 0) {

            currentIndex--;

            changeImage(currentIndex);

        }

    }

});

/*==========================================
RESPONSIVE
==========================================*/

window.addEventListener("resize", function () {

    currentSlide = Math.min(currentSlide, maxSlide());

    updateSlider();

});

   /*==========================================
MAGNIFIC POPUP
==========================================*/

if (
typeof jQuery !== "undefined" &&
jQuery.fn.magnificPopup
){

jQuery(".product-gallery-modal").magnificPopup({

type:"image",

gallery:{
enabled:true
},

callbacks:{

beforeOpen:function(){

this.items = thumbs
? [...thumbs].map(function(thumb){

return{
src:thumb.dataset.large
};

})
:[];

this.index = currentIndex;

}

}

});

}



changeImage(0);

updateSlider();

} 

});

/*==========================================
END PRODUCT GALLERY
==========================================*/

// quantity selector
document.addEventListener("DOMContentLoaded", () => {

    const minusBtn = document.querySelector(".minus");
    const plusBtn = document.querySelector(".plus");
    const qtyInput = document.querySelector(".qty-selector input");

    let qty = 1;

    plusBtn.addEventListener("click", () => {
        qty++;
        qtyInput.value = qty;
    });

    minusBtn.addEventListener("click", () => {
        if (qty > 1) {
            qty--;
            qtyInput.value = qty;
        }
    });

});
// pack selection
// ======================================
// PACK SELECTION
// ======================================

document.addEventListener("DOMContentLoaded", function () {

    const variants = window.productVariants || [];

    const cards = document.querySelectorAll(".pack-card");

    cards.forEach((card) => {

        card.addEventListener("click", function () {

            // Remove active class
            cards.forEach((c) => c.classList.remove("active"));

            this.classList.add("active");

            // Select radio
            const radio = this.querySelector("input[type='radio']");

            if (radio) {
                radio.checked = true;
            }

            const id = Number(radio.value);

            // Update hidden variant input
            const variantInput = document.getElementById("VariantID");

            if (variantInput) {
                variantInput.value = id;
            }

            // Find selected variant
            const variant = variants.find(v => v.id === id);

            if (!variant) return;

            console.log("Selected Variant:", variant);

            // =============================
            // UPDATE PRICE
            // =============================

            const currentPrice = document.querySelector(".product-price .current-price");

            if (currentPrice) {

                currentPrice.innerHTML =
                    "Rs. " +
                    (variant.price / 100).toLocaleString("en-IN");

            }

            // =============================
            // UPDATE OLD PRICE
            // =============================

            const oldPrice = document.querySelector(".product-price .old-price");

            if (oldPrice) {

                if (
                    variant.compare_at_price &&
                    variant.compare_at_price > variant.price
                ) {

                    oldPrice.style.display = "inline";

                    oldPrice.innerHTML =
                        "Rs. " +
                        (variant.compare_at_price / 100).toLocaleString("en-IN");

                } else {

                    oldPrice.style.display = "none";

                }

            }

            // =============================
            // UPDATE DISCOUNT
            // =============================

            const discountBadge =
                document.getElementById("discountBadge");

            if (discountBadge) {

                if (
                    variant.compare_at_price &&
                    variant.compare_at_price > variant.price
                ) {

                    const discount = Math.round(
                        ((variant.compare_at_price - variant.price) /
                            variant.compare_at_price) * 100
                    );

                    discountBadge.innerHTML =
                        `${discount}% OFF`;

                    discountBadge.style.display = "inline-flex";

                } else {

                    discountBadge.innerHTML = "";

                    discountBadge.style.display = "none";

                }

            }

            // =============================
            // UPDATE PRODUCT IMAGE
            // =============================

            const mainImage =
                document.getElementById("MainProductImage");

            if (
                mainImage &&
                variant.featured_image
            ) {

                mainImage.src = variant.featured_image.src;

            }

        });

    });

});



// faq section
document.addEventListener("DOMContentLoaded", () => {

    const items = document.querySelectorAll(".faq-item");

    // Open first item
    const activeItem = document.querySelector(".faq-item.active");

    if(activeItem){
        activeItem.querySelector(".faq-item__body").style.maxHeight =
            activeItem.querySelector(".faq-item__content").scrollHeight + "px";
    }

    items.forEach(item => {

        const btn = item.querySelector(".faq-item__header");
        const body = item.querySelector(".faq-item__body");

        btn.addEventListener("click", () => {

            if(item.classList.contains("active")){

                item.classList.remove("active");
                body.style.maxHeight = null;
                return;

            }

            items.forEach(el => {

                el.classList.remove("active");
                el.querySelector(".faq-item__body").style.maxHeight = null;

            });

            item.classList.add("active");
            body.style.maxHeight = body.scrollHeight + "px";

        });

    });

});

// hide cta buttons
document.addEventListener('DOMContentLoaded', () => {
    const productForm = document.querySelector('#product-form');
    const siteFooter = document.querySelector('.site-footer');

    if (!productForm || !siteFooter) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            productForm.classList.toggle('active', entry.isIntersecting);
        },
        {
            threshold: 0
        }
    );

    observer.observe(siteFooter);
});

// document.querySelectorAll(
// '.product-gallery-thumbnail'
// ).forEach((thumb)=>{

//     thumb.addEventListener('click',function(){

//         const large =
//         this.dataset.large;

//         document.getElementById(
//         'MainProductImage'
//         ).src = large;

//         document
//         .querySelectorAll(
//         '.product-gallery-thumbnail'
//         )
//         .forEach((t)=>{

//             t.classList.remove(
//             'is-active'
//             );

//         });

//         this.classList.add(
//         'is-active'
//         );

//     });

// });



const qtyInput =
document.getElementById(
'QtyInput'
);

const hiddenQty =
document.getElementById(
'ProductQty'
);

document.querySelector(
'.plus'
)?.addEventListener(
'click',
()=>{

let qty =
parseInt(
qtyInput.value
);

qty++;

qtyInput.value =
qty;

hiddenQty.value =
qty;

});

document.querySelector(
'.minus'
)?.addEventListener(
'click',
()=>{

let qty =
parseInt(
qtyInput.value
);

if(qty>1){

qty--;

qtyInput.value =
qty;

hiddenQty.value =
qty;

}

});



document.addEventListener("DOMContentLoaded", function () {

    const checkBtn = document.querySelector(".check-btn");

    if (!checkBtn) return;

    checkBtn.addEventListener("click", function () {

        const pinInput = document.querySelector(".delivery-input input");
        const result = document.getElementById("delivery-result");

        const pin = pinInput.value.trim();

        if (!/^\d{6}$/.test(pin)) {

            result.innerHTML =
                '<span style="color:#d32f2f;">Please enter a valid 6-digit PIN code.</span>';

            return;
        }

        result.innerHTML = "Checking...";

        fetch("https://api.postalpincode.in/pincode/" + pin)

            .then(response => response.json())

            .then(data => {

                if (
                    data[0].Status === "Success" &&
                    data[0].PostOffice &&
                    data[0].PostOffice.length
                ) {

                    const office = data[0].PostOffice[0];

                    // Estimate delivery (2 days from today)
                    const deliveryDate = new Date();
                    deliveryDate.setDate(deliveryDate.getDate() + 2);

                    const options = {
                        weekday: "short",
                        day: "numeric",
                        month: "short"
                    };

                    const formattedDate =
                        deliveryDate.toLocaleDateString("en-IN", options);

                    result.innerHTML = `
                        <div class="delivery-success">
                            <div>✅ Delivery Available</div>
                            <div>${office.District}, ${office.State}</div>
                            <div>
                                Delivery by
                                <strong>${formattedDate}</strong>
                            </div>
                        </div>
                    `;

                } else {

                    result.innerHTML =
                        '<span style="color:#d32f2f;">❌ Delivery not available for this PIN code.</span>';

                }

            })

            .catch(() => {

                result.innerHTML =
                    '<span style="color:#d32f2f;">Unable to check delivery right now.</span>';

            });

    });

});



function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = document.getElementById('cart-count');

      if (count) {
        count.textContent = cart.item_count;
      }
    });
}



document.addEventListener('DOMContentLoaded', function () {

  const buyNowBtn = document.getElementById('buyNowBtn');
  const variantInput = document.getElementById('VariantID');
  const qtyInput = document.getElementById('ProductQty');

  if (!buyNowBtn || !variantInput) return;

  buyNowBtn.addEventListener('click', function () {

    const variantId = variantInput.value;
    const quantity = qtyInput ? qtyInput.value : 1;

    if (!variantId) {
      alert('Please select a product variant.');
      return;
    }

    // Directly go to checkout with selected variant
    window.location.href =
      '/cart/' + variantId + ':' + quantity + '?checkout';

  });

});
